(function($) {
    $(document).ready(function() {
        if($('body').hasClass('page-template-page-about-us')) {
            $('.HeroHeader--inner-valign').css('visibility', 'visible');
        }
    });
}(jQuery));
